// extracted by mini-css-extract-plugin
export default {"wrapper":"ConversationChannelIcon_wrapper__CQUBy","iconWrapper":"ConversationChannelIcon_iconWrapper__xqVw-","icon":"ConversationChannelIcon_icon__mNBv1"};